import { Dispatch } from 'redux';
import { getHeaderCampaigns } from '@client/services/api/headerCampaigns';
import { CampaignForHeader, ActionTypes } from './types';

export const fetchCampaignsStart = () => ({
    type: ActionTypes.FETCH_CAMPAIGNS.REQUEST
});

export const fetchCampaignsSuccess = (campaigns: CampaignForHeader[]) => ({
    type: ActionTypes.FETCH_CAMPAIGNS.SUCCESS,
    payload: campaigns
});

export const fetchCampaignsError = () => ({
    type: ActionTypes.FETCH_CAMPAIGNS.ERROR,

});

export const fetchHeaderCampaigns = () => async (
    dispatch: Dispatch<Action>
) => {
    dispatch(fetchCampaignsStart());
    try {
        const campaigns = await getHeaderCampaigns();
        dispatch(fetchCampaignsSuccess(campaigns));
    } catch (err) {
        dispatch(fetchCampaignsError());
    }
};

export type Action =
    | ReturnType<typeof fetchCampaignsStart>
    | ReturnType<typeof fetchCampaignsSuccess>
    | ReturnType<typeof fetchCampaignsError>;
